// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__2UYQY","label":"CategoryService_label__1-B9J","location":"CategoryService_location__LCcwf"};